
/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { Assessment } from '../../components/assessment/Assessment';
import { NotFound } from '../../../../routes/not-found/NotFound';
import { AssessmentsList } from '../../components/assessments-list/AssessmentsList';
import { useParams } from 'react-router-dom-v5-compat';
import { AssessmentQuestion } from '../../components/assessment/AssessmentQuestion';

export const AssessmentRoute = () => {
  const { initiativeId, surveyId, questionId, questionIndex } = useParams<
    {
      initiativeId: string,
      surveyId: string,
      questionId: string,
      questionIndex: string
    }>();

  if (!initiativeId) {
    return <NotFound />;
  }

  if (surveyId) {
    if (questionId) {
      return (
        <AssessmentQuestion
          initiativeId={initiativeId}
          surveyId={surveyId}
          questionId={questionId}
          questionIndex={questionIndex}
        />
      );
    }
    return <Assessment initiativeId={initiativeId} surveyId={surveyId} />;
  }

  return <AssessmentsList initiativeId={initiativeId} />;
}
